import { getInsulation } from "../../action/building_component/buildingComponent.action";
import { const_var, params } from "../../redux/reducers/reducer";
import { convertToTwoDecimalNumber, editCaseHeritage } from "../../redux/reducers/utils";

export const checkAndupdateOtherInsulationSelection = (insulationData) => {
	if (params.add_right_lean && params.insulation.rightLean.insulationId != 0) {
		if (insulationData && const_var.isInsulaltionForOldQuotes == false && const_var.crmSetting.is_Edit == true) {
			if (insulationData.length > 0 && insulationData.filter((obj) => obj.insulation_id == params.insulation.rightLean.insulationId).length == 0) {
				params.insulation.rightLean.insulationId = insulationData[0].insulation_id; //0
			}
			if (insulationData.length == 0) {
				params.insulation.rightLean.insulationId = 0;
			}
		}
		getInsulation(undefined, "addRightLean");
	}

	if (params.add_left_lean && params.insulation.leftLean.insulationId != 0) {
		if (insulationData && const_var.isInsulaltionForOldQuotes == false && const_var.crmSetting.is_Edit == true) {
			if (insulationData.length > 0 && insulationData.filter((obj) => obj.insulation_id == params.insulation.leftLean.insulationId).length == 0) {
				params.insulation.leftLean.insulationId = insulationData[0].insulation_id; //0
			}
			if (insulationData.length == 0) {
				params.insulation.leftLean.insulationId = 0;
			}
		}
		getInsulation(undefined, "addLeftLean");
	}

	if (params.add_front_lean && params.insulation.frontLean.insulationId != 0) {
		if (insulationData && const_var.isInsulaltionForOldQuotes == false && const_var.crmSetting.is_Edit == true) {
			if (insulationData.length > 0 && insulationData.filter((obj) => obj.insulation_id == params.insulation.frontLean.insulationId).length == 0) {
				params.insulation.frontLean.insulationId = insulationData[0].insulation_id; //0
			}
			if (insulationData.length == 0) {
				params.insulation.frontLean.insulationId = 0;
			}
		}
		getInsulation(undefined, "addFrontLean");
	}

	if (params.add_back_lean && params.insulation.backLean.insulationId != 0) {
		if (insulationData && const_var.isInsulaltionForOldQuotes == false && const_var.crmSetting.is_Edit == true) {
			if (insulationData.length > 0 && insulationData.filter((obj) => obj.insulation_id == params.insulation.backLean.insulationId).length == 0) {
				params.insulation.backLean.insulationId = insulationData[0].insulation_id; //0
			}
			if (insulationData.length == 0) {
				params.insulation.backLean.insulationId = 0;
			}
		}
		getInsulation(undefined, "addBackLean");
	}
};
export const updateCenterBuildingInsulation = (insulation, checkCompare) => {
	if (checkCompare != undefined && checkCompare == "forCompare") {
		if (insulation && insulation.length > 0) {
			const_var.insulationJsonCompare = [];

			for (var i = 0; i < insulation.length; i++) {
				const_var.insulationJsonCompare[insulation[i].insulation_id] = insulation[i].name;
			}
		}
	} else {
		if (insulation && insulation.length > 0 && const_var.a_p_d_a != undefined && const_var.cbInsulation) {
			const_var.cbInsulation = insulation;
			params.insulation.center.showInsulation = true;
			const_var.insulationJson = [];

			for (var i = 0; i < insulation.length; i++) {
				const_var.insulationJson[insulation[i].insulation_id] = insulation[i].name;
				const_var.insulationPriceJson[insulation[i].insulation_id] = insulation[i];
			}
		}
	}
};
export const insulationForCompare = (compareInsulation, fullBuilding, roofOnly, leanType, storage, sideWall) => {
	let insulation,
		insulationPrice,
		roofCost = 0,
		endWallsCost = 0,
		sideWallsCost = 0,
		sideWallsCount = 0,
		closedSideWalls = 0;
	if (const_var.isInsulaltionForOldQuotes && !fullBuilding && !roofOnly) {
		fullBuilding = params.p_f_i;
		roofOnly = params.p_r_o;
	}

	if (fullBuilding) {
		closedSideWalls = const_var.wallsData[leanType].closedSideWalls;
		sideWallsCount = storage ? closedSideWalls - 2 : closedSideWalls;
		if (Object.keys(const_var.wallsData[leanType]).length > 0) {
			roofCost = compareInsulation.roof_insulation_cost != undefined ? parseFloat(compareInsulation.roof_insulation_cost) : 0;
			endWallsCost = compareInsulation.end_cost != undefined ? parseFloat(compareInsulation.end_cost) * parseFloat(const_var.wallsData[leanType].closedEndWalls) : 0;
			sideWallsCost = compareInsulation.side_cost != undefined ? parseFloat(compareInsulation.side_cost) * parseFloat(sideWallsCount) : 0;

			if (storage && compareInsulation.utility_side != undefined && compareInsulation.utility_side != 0) {
				sideWallsCost = parseFloat(sideWallsCost) + parseFloat(compareInsulation.utility_side) * 2;
				if (sideWall != "Open") sideWallsCost = parseFloat(sideWallsCost) + parseFloat(compareInsulation.side_cost) - parseFloat(compareInsulation.utility_side);
			}
			insulationPrice = parseFloat(roofCost) + parseFloat(endWallsCost) + parseFloat(sideWallsCost);
		} else {
			insulationPrice = parseFloat(compareInsulation.roof_insulation_cost);
		}
		insulation = "full";
	}
	if (roofOnly) {
		insulationPrice = parseFloat(compareInsulation.roof_insulation_cost);
		insulation = "roof_only";
	}

	return { insulation, insulationPrice };
};
export const commonFunctionForRoofandFullBuildingInsulationPrice = (data, type, insulationId, params, isCompare = false) => {
	// ############################## Heritage Leanto's cases ##############################
	let insulationPrice = 0;
	let editCheckForHeritage = editCaseHeritage();

	let heritageNoInsulationCaseLeftLean = false;
	let heritageNoInsulationCaseRightLean = false;
	let heritageNoInsulationCaseFrontLean = false;
	let heritageNoInsulationCaseBackLean = false;

	// ################################# Heritage Manufacture check for Front Lean ################################
	if (params.add_front_lean) {
		heritageNoInsulationCaseFrontLean = heritageNoInsulation(params, editCheckForHeritage, isCompare, "frontLean");
	}

	// ################################# Heritage Manufacture check for Back Lean ################################
	if (params.add_back_lean) {
		heritageNoInsulationCaseBackLean = heritageNoInsulation(params, editCheckForHeritage, isCompare, "backLean");
	}

	// ################################# Heritage Manufacture check for Left Lean ################################
	if (params.add_left_lean) {
		heritageNoInsulationCaseLeftLean = heritageNoInsulation(params, editCheckForHeritage, isCompare, "leftLean");
	}

	// ################################# Heritage Manufacture check for Right Lean ################################
	if (params.add_right_lean) {
		heritageNoInsulationCaseRightLean = heritageNoInsulation(params, editCheckForHeritage, isCompare, "rightLean");
	}
	let finalPrice = 0;
	if (data.leanto == undefined && isCompare != true) {
		data.leanto = const_var.leanto;
	}
	if (data.leanto != undefined && data.leanto.length > 0) {
		let insArrayForFrontLeanArray = const_var.insulationArrayForLeantoFront;
		let insArrayForBackLeanArray = const_var.insulationArrayForLeantoBack;
		let insArrayForLeftLeanArray = const_var.insulationArrayForLeantoLeft;
		let insArrayForRightLeanArray = const_var.insulationArrayForLeantoRight;

		if (isCompare == true) {
			for (let i = 0; i < data.leanto.length; i++) {
				if (data.leanto[i].leanto_type == 1) {
					insArrayForLeftLeanArray = data.leanto[i].insulation_type;
				}
				if (data.leanto[i].leanto_type == 2) {
					insArrayForRightLeanArray = data.leanto[i].insulation_type;
				}
				if (data.leanto[i].leanto_type == 3) {
					insArrayForFrontLeanArray = data.leanto[i].insulation_type;
				}
				if (data.leanto[i].leanto_type == 4) {
					insArrayForBackLeanArray = data.leanto[i].insulation_type;
				}
			}
		}

		if (type == "fullBuilding") {
			if (isCompare == true) {
				if (params.add_front_lean && !heritageNoInsulationCaseFrontLean && insulationId != 0 && insArrayForFrontLeanArray != undefined) {
					const insulationRes = calculateInsulation(
						insArrayForFrontLeanArray,
						params.p_f_i,
						params.p_r_o,
						"frontLean",
						params.add_storage_check_front,
						params.p_b_c_b_f_l,
						params.p_b_c_b_f_f,
						params.p_b_c_b_f_b,
						params.p_b_c_b_f_r,
						"front"
					);
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice);
				}
				if (params.add_back_lean && !heritageNoInsulationCaseBackLean && insulationId != 0 && insArrayForBackLeanArray != undefined) {
					const insulationRes = calculateInsulation(
						insArrayForBackLeanArray,
						params.p_f_i,
						params.p_r_o,
						"backLean",
						params.add_storage_check_back,
						params.p_b_c_b_b_l,
						params.p_b_c_b_b_f,
						params.p_b_c_b_b_b,
						params.p_b_c_b_b_r,
						"back"
					);
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice);
				}
				if (params.add_left_lean && !heritageNoInsulationCaseLeftLean && insulationId != 0 && insArrayForLeftLeanArray != undefined) {
					const insulationRes = calculateInsulation(
						insArrayForLeftLeanArray,
						params.p_f_i,
						params.p_r_o,
						"leftLean",
						params.add_storage_check,
						params.p_b_c_b_l,
						params.p_b_c_b_l_f,
						params.p_b_c_b_l_b,
						params.p_b_c_b_l_r
					);
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice, "left");
				}
				if (params.add_right_lean && !heritageNoInsulationCaseRightLean && insulationId != 0 && insArrayForRightLeanArray != undefined) {
					const insulationRes = calculateInsulation(
						insArrayForRightLeanArray,
						params.p_f_i,
						params.p_r_o,
						"rightLean",
						params.add_storage_check_right,
						params.p_b_c_b_r,
						params.p_b_c_b_r_f,
						params.p_b_c_b_r_b,
						params.p_b_c_b_r_r,
						"right"
					);
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice);
				}
			} else {
				if (params.add_front_lean && !heritageNoInsulationCaseFrontLean && insulationId != 0 && insArrayForFrontLeanArray && insArrayForFrontLeanArray[insulationId] != undefined) {
					const insulationRes = calculateInsulation(
						insArrayForFrontLeanArray[insulationId],
						params.p_f_i,
						params.p_r_o,
						"frontLean",
						params.add_storage_check_front,
						params.p_b_c_b_f_l,
						params.p_b_c_b_f_f,
						params.p_b_c_b_f_b,
						params.p_b_c_b_f_r,
						"front"
					);
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice);
				}
				if (params.add_back_lean && !heritageNoInsulationCaseBackLean && insulationId != 0 && insArrayForBackLeanArray && insArrayForBackLeanArray[insulationId] != undefined) {
					const insulationRes = calculateInsulation(
						insArrayForBackLeanArray[insulationId],
						params.p_f_i,
						params.p_r_o,
						"backLean",
						params.add_storage_check_back,
						params.p_b_c_b_b_l,
						params.p_b_c_b_b_f,
						params.p_b_c_b_b_b,
						params.p_b_c_b_b_r,
						"back"
					);
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice);
				}
				if (params.add_left_lean && !heritageNoInsulationCaseLeftLean && insArrayForLeftLeanArray && insulationId != 0 && insArrayForLeftLeanArray[insulationId] != undefined) {
					const insulationRes = calculateInsulation(
						insArrayForLeftLeanArray[insulationId],
						params.p_f_i,
						params.p_r_o,
						"leftLean",
						params.add_storage_check,
						params.p_b_c_b_l,
						params.p_b_c_b_l_f,
						params.p_b_c_b_l_b,
						params.p_b_c_b_l_r,
						"left"
					);
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice);
				}
				if (params.add_right_lean && !heritageNoInsulationCaseRightLean && insulationId != 0 && insArrayForRightLeanArray && insArrayForRightLeanArray[insulationId] != undefined) {
					const insulationRes = calculateInsulation(
						insArrayForRightLeanArray[insulationId],
						params.p_f_i,
						params.p_r_o,
						"rightLean",
						params.add_storage_check_right,
						params.p_b_c_b_r,
						params.p_b_c_b_r_f,
						params.p_b_c_b_r_b,
						params.p_b_c_b_r_r,
						"right"
					);
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice);
				}
			}
		}
		if (type == "roofOnly") {
			if (isCompare == true) {
				if (params.add_front_lean && !heritageNoInsulationCaseFrontLean && insulationId != 0 && insArrayForFrontLeanArray != undefined) {
					finalPrice = parseFloat(finalPrice) + parseFloat(insArrayForFrontLeanArray.roof_insulation_cost);
				}
				if (params.add_back_lean && !heritageNoInsulationCaseBackLean && insulationId != 0 && insArrayForBackLeanArray != undefined) {
					finalPrice = parseFloat(finalPrice) + parseFloat(insArrayForBackLeanArray.roof_insulation_cost);
				}
				if (params.add_left_lean && !heritageNoInsulationCaseLeftLean && insArrayForLeftLeanArray != undefined) {
					finalPrice = parseFloat(finalPrice) + parseFloat(insArrayForLeftLeanArray.roof_insulation_cost);
				}
				if (params.add_right_lean && !heritageNoInsulationCaseRightLean && insulationId != 0 && insArrayForRightLeanArray != undefined) {
					finalPrice = parseFloat(finalPrice) + parseFloat(insArrayForRightLeanArray.roof_insulation_cost);
				}
			} else {
				if (params.add_front_lean && !heritageNoInsulationCaseFrontLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront[params.p_i_o] != undefined) {
					let insulationPriceLeanObj = const_var.leanGetDataFront.insulation.filter((data) => data.insulation_id == params.p_i_o);
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
				}
				if (params.add_back_lean && !heritageNoInsulationCaseBackLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack[params.p_i_o] != undefined) {
					let insulationPriceLeanObj = const_var.leanGetDataBack.insulation.filter((data) => data.insulation_id == params.p_i_o);
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
				}
				if (params.add_left_lean && !heritageNoInsulationCaseLeftLean && const_var.insulationArrayForLeantoLeft && params.p_i_o != 0 && const_var.insulationArrayForLeantoLeft[params.p_i_o] != undefined) {
					let insulationPriceLeanObj = const_var.leanGetDataLeft.insulation.filter((data) => data.insulation_id == params.p_i_o);
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
				}
				if (params.add_right_lean && !heritageNoInsulationCaseRightLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight[params.p_i_o] != undefined) {
					let insulationPriceLeanObj = const_var.leanGetDataRight.insulation.filter((data) => data.insulation_id == params.p_i_o);
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
				}
			}
		}
	}
	return finalPrice;
};
export const calculateInsulation = (buildingInsulation, fullBuilding, roofOnly, leanType, storage, sideWall, frontWall, backWall, rightWall, lean) => {
	let insulation = "roof_only",
		insulationPrice = 0,
		roofCost = 0,
		endWallsCost = 0,
		sideWallsCost = 0,
		sideWallsCount = 0,
		closedSideWalls = 0;
	if (const_var.isInsulaltionForOldQuotes && !fullBuilding && !roofOnly) {
		fullBuilding = params.p_f_i;
		roofOnly = params.p_r_o;
	}

	if (fullBuilding) {
		closedSideWalls = const_var.wallsData[leanType].fullclosedSideWalls;
		sideWallsCount = storage && params.leanStyle[lean] != "gable" ? closedSideWalls - 2 : closedSideWalls; // SE3-I6465
		let endWallCount = const_var.wallsData[leanType].fullclosedEndWalls;
		sideWallsCount = Math.abs(sideWallsCount);

		if (buildingInsulation.end_cost != undefined && Object.keys(const_var.wallsData[leanType]).length > 0) {
			roofCost = buildingInsulation.roof_insulation_cost != undefined ? parseFloat(buildingInsulation.roof_insulation_cost) : 0;
			endWallsCost = buildingInsulation.end_cost != undefined ? parseFloat(buildingInsulation.end_cost) * parseFloat(endWallCount) : 0;
			if (sideWall != "Close") {
				sideWallsCost = buildingInsulation.utility_side != undefined ? parseFloat(buildingInsulation.utility_side) * parseFloat(sideWallsCount) : 0;
			} else {
				sideWallsCost = buildingInsulation.side_cost != undefined ? parseFloat(buildingInsulation.side_cost) * parseFloat(sideWallsCount) : 0;
			}

			if (params.leanStyle[lean] != "gable" && storage && buildingInsulation.utility_opposite_side_cost != undefined && buildingInsulation.utility_opposite_side_cost != 0) {
				//---> SE3-I6465
				sideWallsCost = parseFloat(sideWallsCost) + parseFloat(buildingInsulation.utility_opposite_side_cost);
			}

			insulationPrice = parseFloat(roofCost) + parseFloat(endWallsCost) + parseFloat(sideWallsCost);
		} else {
			if (storage || frontWall != "Open" || backWall != "Open" || sideWall != "Open" || rightWall != "Open") {
				insulationPrice = parseFloat(buildingInsulation.full_building_insulation_cost);
			} else {
				insulationPrice = parseFloat(buildingInsulation.roof_insulation_cost);
			}
		}
		insulation = "full";
	}
	if (roofOnly) {
		insulationPrice = parseFloat(buildingInsulation.roof_insulation_cost);
		insulation = "roof_only";
	}

	return { insulation, insulationPrice };
};
export const calcInsulationPrice = () => {
	let chkPitch = params.p_r_p == 2 ? 2 : params.p_r_p;
	let insulationPriceObj = const_var.cbInsulation?.filter((data) => data.insulation_id == params.p_i_o);
	insulationPriceObj = insulationPriceObj[0];

	let editCheckForHeritage = editCaseHeritage();

	let heritageNoInsulationCaseCenterBuilding = false;
	let heritageNoInsulationCaseLeftLean = false;
	let heritageNoInsulationCaseRightLean = false;
	let heritageNoInsulationCaseFrontLean = false;
	let heritageNoInsulationCaseBackLean = false;

	heritageNoInsulationCaseCenterBuilding = heritageNoInsulation(params, editCheckForHeritage, false, "center");

	if (params.add_front_lean) {
		heritageNoInsulationCaseFrontLean = heritageNoInsulation(params, editCheckForHeritage, false, "frontLean");
	}

	if (params.add_back_lean) {
		heritageNoInsulationCaseBackLean = heritageNoInsulation(params, editCheckForHeritage, false, "backLean");
	}

	if (params.add_left_lean) {
		heritageNoInsulationCaseLeftLean = heritageNoInsulation(params, editCheckForHeritage, false, "leftLean");
	}

	if (params.add_right_lean) {
		heritageNoInsulationCaseRightLean = heritageNoInsulation(params, editCheckForHeritage, false, "rightLean");
	}

	if (params.p_c_i == true) {
		const_var.CBInsulationPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : calcInsulationPriceForWall(insulationPriceObj, "centerBuilding");

		if (
			params.add_front_lean &&
			const_var.leanGetDataFront != undefined &&
			params.insulation.frontLean.insulationId != 0 &&
			const_var.insulationArrayForLeantoFront &&
			const_var.insulationArrayForLeantoFront[params.insulation.frontLean.insulationId] != undefined
		) {
			let insulationPriceLeanObj = const_var.leanGetDataFront.insulation != undefined && const_var.leanGetDataFront.insulation.filter((data) => data.insulation_id == params.insulation.frontLean.insulationId); //const_var.leanGetDataFront.insulation_obj[params.insulation.frontLean.insulationId][params.b_l_t_r_pF + '_12']
			insulationPriceLeanObj = insulationPriceLeanObj[0];

			const_var.FLInsulationPrice = heritageNoInsulationCaseFrontLean == true ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj, "frontLean");
		}

		if (
			params.add_back_lean &&
			const_var.leanGetDataBack != undefined &&
			params.insulation.backLean.insulationId != 0 &&
			const_var.insulationArrayForLeantoBack &&
			const_var.insulationArrayForLeantoBack[params.insulation.backLean.insulationId] != undefined
		) {
			let insulationPriceLeanObj = const_var.leanGetDataBack.insulation != undefined && const_var.leanGetDataBack.insulation.filter((data) => data.insulation_id == params.insulation.backLean.insulationId); //const_var.leanGetDataBack.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			const_var.BLInsulationPrice = heritageNoInsulationCaseBackLean == true ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj, "backLean");
		}

		if (
			params.add_left_lean &&
			const_var.leanGetDataLeft != undefined &&
			const_var.insulationArrayForLeantoLeft &&
			params.insulation.leftLean.insulationId != 0 &&
			const_var.insulationArrayForLeantoLeft[params.insulation.leftLean.insulationId] != undefined
		) {
			let insulationPriceLeanObj = const_var.leanGetDataLeft.insulation != undefined && const_var.leanGetDataLeft.insulation.filter((data) => data.insulation_id == params.insulation.leftLean.insulationId); //const_var.leanGetDataLeft.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']

			insulationPriceLeanObj = insulationPriceLeanObj[0];
			const_var.LLInsulationPrice = heritageNoInsulationCaseLeftLean ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj, "leftLean");
		}

		if (
			params.add_right_lean &&
			const_var.leanGetDataRight != undefined &&
			params.insulation.rightLean.insulationId != 0 &&
			const_var.insulationArrayForLeantoRight &&
			const_var.insulationArrayForLeantoRight[params.insulation.rightLean.insulationId] != undefined
		) {
			let insulationPriceLeanObj = const_var.leanGetDataRight.insulation != undefined && const_var.leanGetDataRight.insulation.filter((data) => data.insulation_id == params.insulation.rightLean.insulationId); //const_var.leanGetDataRight.insulation_obj[params.insulation.rightLean.insulationId][params.b_l_t_r_pR + '_12']
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			const_var.RLInsulationPrice = heritageNoInsulationCaseRightLean ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj, "rightLean");
		}
	}
	if (params.p_c_i != true && params.p_f_i) {
		let finalPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : insulationPriceObj.full_building_insulation_cost;
		if (
			params.add_front_lean &&
			!heritageNoInsulationCaseFrontLean &&
			params.insulation.frontLean.insulationId != 0 &&
			const_var.insulationArrayForLeantoFront &&
			const_var.insulationArrayForLeantoFront[params.insulation.frontLean.insulationId] != undefined
		) {
			let insulationPriceLeanObj = const_var.leanGetDataFront.insulation.filter((data) => data.insulation_id == params.insulation.frontLean.insulationId); //const_var.leanGetDataFront.insulation_obj[params.insulation.frontLean.insulationId][params.b_l_t_r_pF + '_12']
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost);
		}
		if (
			params.add_back_lean &&
			!heritageNoInsulationCaseBackLean &&
			params.insulation.backLean.insulationId != 0 &&
			const_var.insulationArrayForLeantoBack &&
			const_var.insulationArrayForLeantoBack[params.insulation.backLean.insulationId] != undefined
		) {
			let insulationPriceLeanObj = const_var.leanGetDataBack.insulation.filter((data) => data.insulation_id == params.insulation.backLean.insulationId); //const_var.leanGetDataBack.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost);
		}
		if (
			params.add_left_lean &&
			!heritageNoInsulationCaseLeftLean &&
			const_var.insulationArrayForLeantoLeft &&
			params.insulation.leftLean.insulationId != 0 &&
			const_var.insulationArrayForLeantoLeft[params.insulation.leftLean.insulationId] != undefined
		) {
			let insulationPriceLeanObj = const_var.leanGetDataLeft.insulation.filter((data) => data.insulation_id == params.insulation.leftLean.insulationId); //const_var.leanGetDataLeft.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost);
		}
		if (
			params.add_right_lean &&
			!heritageNoInsulationCaseRightLean &&
			params.insulation.rightLean.insulationId != 0 &&
			const_var.insulationArrayForLeantoRight &&
			const_var.insulationArrayForLeantoRight[params.insulation.rightLean.insulationId] != undefined
		) {
			let insulationPriceLeanObj = const_var.leanGetDataRight.insulation.filter((data) => data.insulation_id == params.insulation.rightLean.insulationId); //const_var.leanGetDataRight.insulation_obj[params.insulation.rightLean.insulationId][params.b_l_t_r_pR + '_12']
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost);
		}
		const_var.CBInsulationPrice = finalPrice;
	}
	if (params.p_c_i != true && params.p_r_o) {
		let finalPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : insulationPriceObj.roof_insulation_cost;
		if (params.add_front_lean && !heritageNoInsulationCaseFrontLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront[params.p_i_o] != undefined) {
			let insulationPriceLeanObj = const_var.leanGetDataFront.insulation.filter((data) => data.insulation_id == params.p_i_o);
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
		}
		if (params.add_back_lean && !heritageNoInsulationCaseBackLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack[params.p_i_o] != undefined) {
			let insulationPriceLeanObj = const_var.leanGetDataBack.insulation.filter((data) => data.insulation_id == params.p_i_o);
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
		}
		if (params.add_left_lean && !heritageNoInsulationCaseLeftLean && const_var.insulationArrayForLeantoLeft && params.p_i_o != 0 && const_var.insulationArrayForLeantoLeft[params.p_i_o] != undefined) {
			let insulationPriceLeanObj = const_var.leanGetDataLeft.insulation.filter((data) => data.insulation_id == params.p_i_o);
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
		}
		if (params.add_right_lean && !heritageNoInsulationCaseRightLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight[params.p_i_o] != undefined) {
			let insulationPriceLeanObj = const_var.leanGetDataRight.insulation.filter((data) => data.insulation_id == params.p_i_o);
			insulationPriceLeanObj = insulationPriceLeanObj[0];
			finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
		}

		const_var.CBInsulationPrice = finalPrice;
	}
};
export const calcInsulationPriceForWall = (insulationPriceObj, isFor) => {
	let finalInsCost = 0;

	let isFreeStandingBuilding = false;
	if (params.p_b_t != undefined) {
		let selBuildingObj = Object.entries(const_var.defaultBuildingArr).find(([key, obj]) => obj.building_id == params.p_b_t);

		selBuildingObj = selBuildingObj && selBuildingObj.length > 0 ? selBuildingObj[1] : 0;
		isFreeStandingBuilding = selBuildingObj != 0 ? (selBuildingObj?.image_name.includes("Free_Standing") ? true : false) : false;
		const_var.isFreeStandingBuilding = isFreeStandingBuilding;
	}

	if (isFor == "centerBuilding" && const_var.insulationPriceJson.insulation_wall && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0) {
		Object.entries(const_var.insulationPriceJson.insulation_wall).map(([key, val]) => {
			if ((key == "p_b_w" && val == true && params.p_b_w === "Close") || (key == "p_f_w" && val == true && params.p_f_w === "Close")) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if ((key == "p_l_w" && !isFreeStandingBuilding && val == true && params.p_l_w === "Close") || (key == "p_r_w" && val == true && params.p_r_w === "Close")) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "p_l_w" && val == true && isFreeStandingBuilding && params.p_l_w === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.slope_side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}

			if (params.p_u_c) {
				if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
				}
				if ((key == "storage_right" && val == true) || (key == "storage_left" && val == true && !isFreeStandingBuilding)) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				}
				if (key == "storage_left" && val == true && isFreeStandingBuilding) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_slope_side_cost || 0);
				}
			}
			if (params.cB_addStorage_check_left) {
				if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_end || 0);
				}
				if (key == "storage_right" && val == true) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.pitch_side || 0);
				}
				if (key == "storage_left" && val == true) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				}
			}
			if (params.cB_addStorage_check_right) {
				if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_end || 0);
				}
				if (key == "storage_left" && val == true) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.pitch_side || 0);
				}
				if (key == "storage_right" && val == true) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				}
			}

			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	if (isFor == "frontLean" && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront.insulation_wall && Object.keys(const_var.insulationArrayForLeantoFront.insulation_wall).length > 0) {
		Object.entries(const_var.insulationArrayForLeantoFront.insulation_wall).map(([key, val]) => {
			if ((key == "p_b_c_b_f_b" && val == true && params.p_b_c_b_f_b === "Close") || (key == "p_b_c_b_f_f" && val == true && params.p_b_c_b_f_f === "Close")) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "p_b_c_b_f_l" && val == true && params.p_b_c_b_f_l === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "p_b_c_b_f_r" && val == true && params.p_b_c_b_f_r === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}
			if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "storage_left" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
			}
			if (key == "storage_right" && val == true) {
				if (params.leanStyle.front == "gable") {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				} else {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_opposite_side_cost || 0);
				}
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	if (isFor == "backLean" && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack.insulation_wall && Object.keys(const_var.insulationArrayForLeantoBack.insulation_wall).length > 0) {
		Object.entries(const_var.insulationArrayForLeantoBack.insulation_wall).map(([key, val]) => {
			if ((key == "p_b_c_b_b_f" && val == true && params.p_b_c_b_b_f === "Close") || (key == "p_b_c_b_b_b" && val == true && params.p_b_c_b_b_b === "Close")) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "p_b_c_b_b_l" && val == true && params.p_b_c_b_b_l === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "p_b_c_b_b_r" && val == true && params.p_b_c_b_b_r === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}
			if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "storage_right" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
			}
			if (key == "storage_left" && val == true) {
				if (params.leanStyle.back == "gable") {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				} else {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_opposite_side_cost || 0);
				}
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	if (isFor == "leftLean" && const_var.insulationArrayForLeantoLeft && const_var.insulationArrayForLeantoLeft.insulation_wall && Object.keys(const_var.insulationArrayForLeantoLeft.insulation_wall).length > 0) {
		Object.entries(const_var.insulationArrayForLeantoLeft.insulation_wall).map(([key, val]) => {
			if ((key == "p_b_c_b_l_f" && val == true && params.p_b_c_b_l_f === "Close") || (key == "p_b_c_b_l_b" && val == true && params.p_b_c_b_l_b === "Close")) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "p_b_c_b_l" && val == true && params.p_b_c_b_l === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "p_b_c_b_l_r" && val == true && params.p_b_c_b_l_r === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}
			if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "storage_left" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
			}
			if (key == "storage_right" && val == true) {
				if (params.leanStyle.left == "gable") {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				} else {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_opposite_side_cost || 0);
				}
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	if (isFor == "rightLean" && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight.insulation_wall && Object.keys(const_var.insulationArrayForLeantoRight.insulation_wall).length > 0) {
		Object.entries(const_var.insulationArrayForLeantoRight.insulation_wall).map(([key, val]) => {
			if ((key == "p_b_c_b_r_b" && val == true && params.p_b_c_b_r_b === "Close") || (key == "p_b_c_b_r_f" && val == true && params.p_b_c_b_r_f === "Close")) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "p_b_c_b_r" && val == true && params.p_b_c_b_r === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "p_b_c_b_r_r" && val == true && params.p_b_c_b_r_r === "Close") {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}
			if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "storage_left" && val == true) {
				if (params.leanStyle.right == "gable") {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				} else {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_opposite_side_cost || 0);
				}
			}
			if (key == "storage_right" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	return convertToTwoDecimalNumber(finalInsCost);
};

export const calcInsulationPriceForCompare = (data, newParam, leanToData = undefined) => {
	let selInsulationId = data.pricing_data.insulation.filter((obj) => obj.insulation_id == newParam.p_i_o);

	selInsulationId = selInsulationId && selInsulationId.length > 0 ? selInsulationId[0] : data.pricing_data.insulation[0];

	const_var.compareInsId = selInsulationId.insulation_id;

	let insulationPriceObj = selInsulationId;

	let heritageNoInsulationCaseCenterBuilding = false;
	let heritageNoInsulationCaseLeftLean = false;
	let heritageNoInsulationCaseRightLean = false;
	let heritageNoInsulationCaseFrontLean = false;
	let heritageNoInsulationCaseBackLean = false;

	heritageNoInsulationCaseCenterBuilding = heritageNoInsulation(newParam, false, true, "center", data);

	if (newParam.m_s_n == 153 && (newParam.p_r_s == 1 || newParam.p_r_s == 2) && newParam.p_h > 10) {
		heritageNoInsulationCaseCenterBuilding = true;
	} else {
		heritageNoInsulationCaseCenterBuilding = false;
	}

	if (params.add_front_lean) {
		heritageNoInsulationCaseFrontLean = heritageNoInsulation(newParam, false, true, "frontLean", data);
	}

	if (params.add_back_lean) {
		heritageNoInsulationCaseBackLean = heritageNoInsulation(newParam, false, true, "backLean", data);
	}

	if (params.add_left_lean) {
		heritageNoInsulationCaseLeftLean = heritageNoInsulation(newParam, false, true, "leftLean", data);
	}

	if (params.add_right_lean) {
		heritageNoInsulationCaseRightLean = heritageNoInsulation(newParam, false, true, "rightLean", data);
	}

	if (params.p_c_i) {
		if (const_var.a_p_d_a && const_var.cbInsulation && const_var.insulationPriceJson && const_var.insulationPriceJson.insulation_wall) {
			let selWallObj = {};
			selWallObj = const_var.insulationPriceJson.insulation_wall;
			const_var.CompareCBInsulationPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : calcCompareInsulationPriceForWall(insulationPriceObj, "centerBuilding", selWallObj, newParam);
		}

		if ((newParam.add_front_lean || newParam.add_back_lean || newParam.add_left_lean || newParam.add_right_lean) && leanToData != undefined && leanToData.length > 0) {
			for (let i = 0; i < leanToData.length; i++) {
				if (
					newParam.add_front_lean &&
					!heritageNoInsulationCaseFrontLean &&
					leanToData[i].leanto_type == 3 &&
					newParam.insulation.frontLean.insulationId != 0 &&
					leanToData[i].pricing_data.insulation &&
					const_var.insulationArrayForLeantoFront &&
					const_var.insulationArrayForLeantoFront.insulation_wall &&
					Object.keys(const_var.insulationArrayForLeantoFront.insulation_wall).length > 0
				) {
					let RP = newParam.b_l_t_r_pF.replace("12", "");
					let insulationPriceLeanObj =
						leanToData[i].pricing_data.insulation != undefined && leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.frontLean.insulationId); //const_var.leanGetDataFront.insulation_obj[params.insulation.frontLean.insulationId][params.b_l_t_r_pF + '_12']
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					let selLeanWallObj = const_var.insulationArrayForLeantoFront.insulation_wall;

					const_var.CompareFLInsulationPrice = calcCompareInsulationPriceForWall(insulationPriceLeanObj, "frontLean", selLeanWallObj, newParam);
				}
				if (
					newParam.add_back_lean &&
					!heritageNoInsulationCaseBackLean &&
					leanToData[i].leanto_type == 4 &&
					newParam.insulation.backLean.insulationId != 0 &&
					leanToData[i].pricing_data.insulation &&
					const_var.insulationArrayForLeantoBack &&
					const_var.insulationArrayForLeantoBack.insulation_wall &&
					Object.keys(const_var.insulationArrayForLeantoBack.insulation_wall).length > 0
				) {
					let RP = newParam.b_l_t_r_pB.replace("12", "");

					let insulationPriceLeanObj =
						leanToData[i].pricing_data.insulation != undefined && leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.backLean.insulationId); //const_var.leanGetDataBack.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					let selLeanWallObj = const_var.insulationArrayForLeantoBack.insulation_wall;
					const_var.CompareBLInsulationPrice = calcCompareInsulationPriceForWall(insulationPriceLeanObj, "backLean", selLeanWallObj, newParam);
				}
				if (
					newParam.add_left_lean &&
					!heritageNoInsulationCaseLeftLean &&
					leanToData[i].leanto_type == 1 &&
					newParam.insulation.leftLean.insulationId != 0 &&
					leanToData[i].pricing_data &&
					leanToData[i].pricing_data.insulation &&
					const_var.insulationArrayForLeantoLeft &&
					const_var.insulationArrayForLeantoLeft.insulation_wall &&
					Object.keys(const_var.insulationArrayForLeantoLeft.insulation_wall).length > 0
				) {
					let RP = newParam.b_l_t_r_p.replace("12", "");
					let insulationPriceLeanObj =
						leanToData[i].pricing_data.insulation != undefined && leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.leftLean.insulationId); //const_var.leanGetDataLeft.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					let selLeanWallObj = const_var.insulationArrayForLeantoLeft.insulation_wall;
					const_var.CompareLLInsulationPrice = calcCompareInsulationPriceForWall(insulationPriceLeanObj, "leftLean", selLeanWallObj, newParam);
				}
				if (
					newParam.add_right_lean &&
					!heritageNoInsulationCaseRightLean &&
					leanToData[i].leanto_type == 2 &&
					newParam.insulation.rightLean.insulationId != 0 &&
					leanToData[i].pricing_data &&
					leanToData[i].pricing_data.insulation &&
					const_var.insulationArrayForLeantoRight &&
					const_var.insulationArrayForLeantoRight.insulation_wall &&
					Object.keys(const_var.insulationArrayForLeantoRight.insulation_wall).length > 0
				) {
					let RP = newParam.b_l_t_r_pR.replace("12", "");
					let insulationPriceLeanObj =
						leanToData[i].pricing_data.insulation != undefined && leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.rightLean.insulationId);
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					let selLeanWallObj = const_var.insulationArrayForLeantoRight.insulation_wall;
					const_var.CompareRLInsulationPrice = calcCompareInsulationPriceForWall(insulationPriceLeanObj, "rightLean", selLeanWallObj, newParam);
				}
			}
		}
	}

	if (newParam.p_f_i) {
		let finalPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : insulationPriceObj?.full_building_insulation_cost;
		if ((newParam.add_front_lean || newParam.add_back_lean || newParam.add_left_lean || newParam.add_right_lean) && leanToData != undefined && leanToData.length > 0) {
			for (let i = 0; i < leanToData.length; i++) {
				if (newParam.add_front_lean && !heritageNoInsulationCaseFrontLean && leanToData[i].leanto_type == 3 && leanToData[i].pricing_data.insulation && newParam.insulation.frontLean.insulationId != 0) {
					let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0];

					let insulationPriceLeanObj = leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.frontLean.insulationId);

					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost);
				}
				if (newParam.add_back_lean && !heritageNoInsulationCaseBackLean && leanToData[i].leanto_type == 4 && leanToData[i].pricing_data.insulation && newParam.insulation.backLean.insulationId != 0) {
					let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0];
					let insulationPriceLeanObj = leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.backLean.insulationId); //leanToData[i].pricing_data.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']

					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost);
				}
				if (newParam.add_left_lean && !heritageNoInsulationCaseLeftLean && leanToData[i].leanto_type == 1 && leanToData[i].pricing_data.insulation && newParam.insulation.leftLean.insulationId != 0) {
					let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0];
					let insulationPriceLeanObj = leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.leftLean.insulationId); //leanToData[i].pricing_data.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']

					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost);
				}
				if (newParam.add_right_lean && !heritageNoInsulationCaseRightLean && leanToData[i].leanto_type == 2 && leanToData[i].pricing_data.insulation && newParam.insulation.rightLean.insulationId != 0) {
					let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0];
					let insulationPriceLeanObj = leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.rightLean.insulationId); //leanToData[i].pricing_data.insulation.insulation_obj[params.insulation.rightLean.insulationId][params.b_l_t_r_pR + '_12']
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost);
				}
			}
		}
		const_var.CompareCBInsulationPrice = convertToTwoDecimalNumber(finalPrice);
	}

	if (newParam.p_r_o) {
		let finalPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : insulationPriceObj?.roof_insulation_cost;
		// console.log('aaa finalPrice',finalPrice);
		if ((newParam.add_front_lean || newParam.add_back_lean || newParam.add_left_lean || newParam.add_right_lean) && leanToData != undefined) {
			for (let i = 0; i < leanToData.length; i++) {
				if (newParam.add_front_lean && !heritageNoInsulationCaseFrontLean && leanToData[i].leanto_type == 3 && leanToData[i].pricing_data.insulation && newParam.insulation.frontLean.insulationId != 0) {
					let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0];
					let insulationPriceLeanObj = leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.frontLean.insulationId);
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
				}
				if (newParam.add_back_lean && !heritageNoInsulationCaseBackLean && leanToData[i].leanto_type == 4 && leanToData[i].pricing_data.insulation && newParam.insulation.backLean.insulationId != 0) {
					let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0];
					let insulationPriceLeanObj = leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.backLean.insulationId); //leanToData[i].pricing_data.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
				}
				if (newParam.add_left_lean && !heritageNoInsulationCaseLeftLean && leanToData[i].leanto_type == 1 && leanToData[i].pricing_data.insulation && newParam.insulation.leftLean.insulationId != 0) {
					let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0];
					let insulationPriceLeanObj = leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.leftLean.insulationId); //leanToData[i].pricing_data.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
				}
				if (newParam.add_right_lean && !heritageNoInsulationCaseRightLean && leanToData[i].leanto_type == 2 && leanToData[i].pricing_data.insulation && newParam.insulation.rightLean.insulationId != 0) {
					let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0];
					let insulationPriceLeanObj = leanToData[i].pricing_data.insulation.filter((data) => data.insulation_id == newParam.insulation.rightLean.insulationId);
					insulationPriceLeanObj = insulationPriceLeanObj[0];
					finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost);
				}
			}
		}
		const_var.CompareCBInsulationPrice = finalPrice;
	}
};

export const calcCompareInsulationPriceForWall = (insulationPriceObj, isFor, wallData, newParam) => {
	let finalInsCost = 0;

	let isFreeStandingBuilding = const_var.isFreeStandingBuilding;

	if (isFor == "centerBuilding" && wallData && Object.keys(wallData).length > 0 && insulationPriceObj != undefined) {
		Object.entries(wallData).map(([key, val]) => {
			if ((key == "p_b_w" && val == true) || (key == "p_f_w" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if ((key == "p_l_w" && !isFreeStandingBuilding && val == true) || (key == "p_r_w" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "p_l_w" && val == true && isFreeStandingBuilding) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.slope_side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}

			if (newParam.p_u_c) {
				if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
				}
				if ((key == "storage_right" && val == true) || (key == "storage_left" && val == true && !isFreeStandingBuilding)) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				}
				if (key == "storage_left" && val == true && isFreeStandingBuilding) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_slope_side_cost || 0);
				}
			}
			if (newParam.cB_addStorage_check_left) {
				if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_end || 0);
				}
				if (key == "storage_right" && val == true) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.pitch_side || 0);
				}
				if (key == "storage_left" && val == true) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				}
			}
			if (newParam.cB_addStorage_check_right) {
				if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_end || 0);
				}
				if (key == "storage_left" && val == true) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.pitch_side || 0);
				}
				if (key == "storage_right" && val == true) {
					finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
				}
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	if (isFor == "frontLean" && wallData && Object.keys(wallData).length > 0 && insulationPriceObj != undefined) {
		Object.entries(wallData).map(([key, val]) => {
			if ((key == "p_b_c_b_f_b" && val == true) || (key == "p_b_c_b_f_f" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "p_b_c_b_f_l" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}
			if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "storage_left" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
			}
			if (key == "storage_right" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_opposite_side_cost || 0);
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	if (isFor == "backLean" && wallData && Object.keys(wallData).length > 0 && insulationPriceObj != undefined) {
		Object.entries(wallData).map(([key, val]) => {
			if ((key == "p_b_c_b_b_f" && val == true) || (key == "p_b_c_b_b_b" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "p_b_c_b_b_l" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}
			if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "storage_right" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
			}
			if (key == "storage_left" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_opposite_side_cost || 0);
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	if (isFor == "leftLean" && wallData && Object.keys(wallData).length > 0 && insulationPriceObj != undefined) {
		Object.entries(wallData).map(([key, val]) => {
			if ((key == "p_b_c_b_l_f" && val == true) || (key == "p_b_c_b_l_b" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "p_b_c_b_l" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}
			if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "storage_left" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
			}
			if (key == "storage_right" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_opposite_side_cost || 0);
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	if (isFor == "rightLean" && wallData && Object.keys(wallData).length > 0 && insulationPriceObj != undefined) {
		Object.entries(wallData).map(([key, val]) => {
			if ((key == "p_b_c_b_r_b" && val == true) || (key == "p_b_c_b_r_f" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "p_b_c_b_r" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.side_cost || 0);
			}
			if (key == "full_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.roof_insulation_cost || 0);
			}
			if (key == "open_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.open_roof_cost || 0);
			}
			if ((key == "storage_front" && val == true) || (key == "storage_back" && val == true)) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.end_cost || 0);
			}
			if (key == "storage_left" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_opposite_side_cost || 0);
			}
			if (key == "storage_right" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_side || 0);
			}
			if (key == "storage_roof" && val == true) {
				finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj?.utility_roof_cost || 0);
			}
		});
	}
	return convertToTwoDecimalNumber(finalInsCost);
};
export const commonFunctionForInsulationCalculations = (price, insulationID) => {
	let chkInsulationID = insulationID != undefined ? insulationID : params.selectedInsulationId;
	if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0) {
		for (var i = 0; i < const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length; i++) {
			if (
				const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != undefined ||
				(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != null &&
					const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category == chkInsulationID)
			) {
				if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component == "insulation") {
					if (chkInsulationID != 0) {
						if (
							const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != undefined ||
							const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != null
						) {
							if (chkInsulationID == const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category) {
								if (
									price >= parseInt(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].from) &&
									price <= parseInt(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].to)
								) {
									const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
									return true;
								}
							}
						}
					}
				}
			}
		}
	}
};
export const extractDataFromInsulation = (data) => {
	let extractedObjects = [];
	if (data.insulationType == "custom") {
		extractedObjects = Object.values(data)
			?.filter((item) => {
				if (typeof item == "object") {
					return item;
				}
			})
			?.map((val) => Object.values(val)?.[0])
			?.filter((item) => item != undefined);
	} else if (data.insulationType) {
		extractedObjects = Object.values(data)?.filter((item) => {
			if (typeof item == "object") {
				return item;
			}
		});
	}
	return extractedObjects;
};
const checkForInsulation = () => {
	let editCheckForHeritage = editCaseHeritage();

	let isinsulationApplicable = heritageNoInsulation(params, editCheckForHeritage, false, "all");
	if (isinsulationApplicable) {
		params.p_c_i = false;
		params.p_f_i = false;
		params.p_r_o = false;
	}
};
export const heritageNoInsulation = (newParams, editCase, isFromCompare, type, compareMnfData = undefined) => {
	let frontLeanData = undefined;
	let backLeanData = undefined;
	let leftLeanData = undefined;
	let rightLeanData = undefined;
	let heritageNoInsulationCase = false;

	let height = 0;
	let roofStyle = 0;
	let leanToData = [];
	let manufacturer = 153;

	if (isFromCompare === true) {
		height = newParams.height ? newParams.height : newParams.p_h;
		roofStyle = newParams.roof_style ? newParams.roof_style : newParams.p_r_s;

		if (compareMnfData !== undefined && compareMnfData.post_data && compareMnfData.post_data.building && compareMnfData.post_data.building.leanto && compareMnfData.post_data.building.leanto.length > 0) {
			leanToData = compareMnfData.post_data.building.leanto;
		}
		manufacturer = newParams.manufacturer ? newParams.manufacturer : newParams.m_s_n;
	} else {
		height = newParams.p_h;
		roofStyle = newParams.p_r_s;
		if (const_var.post_data.building !== undefined && const_var.post_data.building.leanto.length > 0) {
			leanToData = const_var.post_data.building.leanto;
		}
		manufacturer = newParams.m_s_n;
	}
	if (leanToData !== undefined && leanToData.length > 0) {
		for (var i = 0; i <= leanToData.length - 1; i++) {
			if (leanToData[i].leanto_type === 2) {
				rightLeanData = leanToData[i];
			} else if (leanToData[i].leanto_type === 1) {
				leftLeanData = leanToData[i];
			} else if (leanToData[i].leanto_type === 3) {
				frontLeanData = leanToData[i];
			} else if (leanToData[i].leanto_type === 4) {
				backLeanData = leanToData[i];
			}
		}
	}

	if (
		newParams.singleSlope != true &&
		((const_var.crmSetting.is_Edit != true && newParams.m_s_n == 153 && (newParams.p_r_s == 1 || newParams.p_r_s == 2) && newParams.p_h > 10) || (editCase == true && newParams.p_h > 10))
	) {
		if (type == "all") {
			if (
				(newParams.add_left_lean == true && leftLeanData != undefined && leftLeanData.height <= 10) ||
				(newParams.add_right_lean == true && rightLeanData != undefined && rightLeanData.height <= 10) ||
				(newParams.add_front_lean == true && frontLeanData != undefined && frontLeanData.height <= 10) ||
				(newParams.add_back_lean == true && backLeanData != undefined && backLeanData.height <= 10)
			) {
				heritageNoInsulationCase = false;
			} else {
				heritageNoInsulationCase = true;
			}
		}

		if (type === "center") {
			if ((roofStyle == 1 || roofStyle == 2) && height > 10) {
				heritageNoInsulationCase = true;
			} else {
				heritageNoInsulationCase = false;
			}
			return heritageNoInsulationCase;
		}

		if (type === "leftLean") {
			if (newParams.add_left_lean == true && leftLeanData != undefined && leftLeanData.height > 10) {
				heritageNoInsulationCase = true;
			} else {
				heritageNoInsulationCase = false;
			}
		}

		if (type === "rightLean") {
			if (newParams.add_right_lean == true && rightLeanData != undefined && rightLeanData.height > 10) {
				heritageNoInsulationCase = true;
			} else {
				heritageNoInsulationCase = false;
			}
		}
		if (type === "frontLean") {
			if (newParams.add_front_lean == true && frontLeanData != undefined && frontLeanData.height > 10) {
				heritageNoInsulationCase = true;
			} else {
				heritageNoInsulationCase = false;
			}
		}
		if (type === "backLean") {
			if (newParams.add_back_lean == true && backLeanData != undefined && backLeanData.height > 10) {
				heritageNoInsulationCase = true;
			} else {
				heritageNoInsulationCase = false;
			}
		}
	} else {
		let singleSlopeHeight =
			const_var.c_m_a[newParams.p_b_t] != undefined && const_var.c_m_a[newParams.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[newParams.p_b_t].fixed_new_leg_width.length > 0
				? Math.floor(newParams.p_h - (newParams.p_w * newParams.p_r_p) / 12)
				: Math.round(newParams.p_h - (newParams.p_w * newParams.p_r_p) / 12);

		if ((const_var.crmSetting.is_Edit != true && newParams.m_s_n == 153 && (roofStyle == 1 || roofStyle == 2) && singleSlopeHeight > 10) || (editCase == true && singleSlopeHeight > 10)) {
			params.p_i_o = 0;
			params.insulation.center.insulationId = 0;
			params.p_c_i = false;
			params.p_f_i = false;
			params.p_r_o = false;
			heritageNoInsulationCase = true;
		}
	}

	if (const_var.insulationJson && const_var.insulationJson.length > 0 && heritageNoInsulationCase && !params.p_c_i) {
		if (type == "all") {
			params.p_c_i = false;
			params.p_f_i = false;
			params.p_r_o = false;
		} else {
			checkForInsulation();
		}
	}

	return heritageNoInsulationCase;
};

